import React, { memo } from "react";
import { Card } from "antd";
import CommonCertificates from "./CommonCertificates";

// Admin > Certificates: ISO, CM3, Labour Hire and any type a client adds, on
// one screen. (Public Liability and WorkCover are on Business Insurance.)
const Certificates = () => (
  <Card>
    <CommonCertificates />
  </Card>
);

export default memo(Certificates);
